import i18n from 'i18next';
import english from "./english.json";
import french from "./french.json";
import { initReactI18next } from "react-i18next"

i18n.use(initReactI18next).init({
    compatibilityJSON: 'v3',
    lng: 'en',
    resources: {
        en: english,
        fr: french,
    },
    lng: 'en', // Default language
    fallbackLng: 'en',
    /*interpolation: {
        escapeValue: false 
      },*/
    react: {
        useSuspense: false,
    }
});
export default i18n;
